import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=3a621865&scoped=true&"
import script from "./Project.vue?vue&type=script&lang=js&"
export * from "./Project.vue?vue&type=script&lang=js&"
import style0 from "./Project.vue?vue&type=style&index=0&id=3a621865&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a621865",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a621865')) {
      api.createRecord('3a621865', component.options)
    } else {
      api.reload('3a621865', component.options)
    }
    module.hot.accept("./Project.vue?vue&type=template&id=3a621865&scoped=true&", function () {
      api.rerender('3a621865', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/Project.vue"
export default component.exports